/**
 * BTRoblox - Making Roblox Better
 *
 * Exposes /res/* and /css/* scoped to `*://*.roblox.com/*`, so only Roblox can detect it.
 * Manifest verified against version 3.6.22.
 */
import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'hbkpclpemjeibhioopcebchdmohaieln';
export const btroblox: ExtensionDefinition = {
  id: ID,
  name: 'BTRoblox - Making Roblox Better',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 4_000_000,
  requiredOrigin: 'https://www.roblox.com',
  notes: 'Scoped to roblox.com. Its user base skews young, which makes enumeration here more sensitive.',
  signals: [
    { id: 'war-icon', kind: 'web-accessible-resource',
      description: 'Load res/icon_128.png via <img> — matched by the /res/* grant to roblox.com.',
      weight: 1, run: () => probeImage(ID, 'res/icon_128.png') },
  ],
};
